import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=8dde8f14&scoped=true"
import script from "./GalleryCard.vue?vue&type=script&lang=js"
export * from "./GalleryCard.vue?vue&type=script&lang=js"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&id=8dde8f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dde8f14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VChip,VIcon,VLazy})
